import { render, staticRenderFns } from "./AlcadasSolicitacao.vue?vue&type=template&id=9edc02d2&"
import script from "./AlcadasSolicitacao.vue?vue&type=script&lang=js&"
export * from "./AlcadasSolicitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports